import { action } from 'easy-peasy';
import { IActionSetRelease } from '../types';

const setRelease: IActionSetRelease = action((state, release) => {
  state.current = release;
});

export default setRelease;
